// extracted by mini-css-extract-plugin
module.exports = {"transactionHistory":"TransactionHistory_transactionHistory__Cjh29"};